import React, { useEffect } from 'react';
import Hero from '../components/home/Hero';
import WhoWeHelp from '../components/home/WhoWeHelp';
import CoreServices from '../components/home/CoreServices';
import BusinessPlans from '../components/home/BusinessPlans';
import Audiences from '../components/home/Audiences';
import ServicesCards from '../components/home/ServicesCards';
import FractionalCTO from '../components/home/FractionalCTO';
import FinalCTA from '../components/home/FinalCTA';
import '../styles/home.css';

const HOME_TITLE = 'ManagedSite.net | Website, Email, Hosting and Technical Support';
const HOME_DESCRIPTION =
  'ManagedSite.net provides website management, web design, business email support, managed hosting, security, technical support, agency services, and technology consulting.';

const Home = () => {
  useEffect(() => {
    document.title = HOME_TITLE;
    const updateMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    updateMeta('meta[name="description"]', 'content', HOME_DESCRIPTION);
    updateMeta('meta[property="og:title"]', 'content', HOME_TITLE);
    updateMeta('meta[property="og:description"]', 'content', HOME_DESCRIPTION);
    updateMeta('meta[property="twitter:title"]', 'content', HOME_TITLE);
    updateMeta('meta[property="twitter:description"]', 'content', HOME_DESCRIPTION);
  }, []);

  return (
    <div className="home-page w-full">
      <Hero />
      <WhoWeHelp />
      <CoreServices />
      <BusinessPlans />
      <Audiences />
      <ServicesCards />
      <FractionalCTO />
      <FinalCTA />
    </div>
  );
};

export default Home;